import { Dispatch, SetStateAction } from 'react';
import { SetURLSearchParams } from 'react-router-dom';
import { LocationState } from 'src/types/LocationState';
import { Filter } from 'src/utils/composeFilter';
import {
    ORDER_BY_NUMBER_QUERY_PARAM,
    ORDER_BY_STRING_QUERY_PARAM,
} from 'src/modules/common/constants';
import { initLocationState } from 'src/locationStateContext';

export const createUpdateUrlAndState = (
    setSearchParams: SetURLSearchParams,
    searchParams: URLSearchParams,
    setLocationState: Dispatch<SetStateAction<LocationState>>,
) => (newFilter: Filter) => {
    const newSearch = new URLSearchParams();
    Object.entries(newFilter).forEach(([name, value]) => {
        if (value.length > 0) {
            newSearch.set(name, JSON.stringify(value));
        }
    });
    newSearch.delete(ORDER_BY_NUMBER_QUERY_PARAM);
    newSearch.delete(ORDER_BY_STRING_QUERY_PARAM);

    const input = searchParams.get('input');
    const kind = searchParams.get('kind');
    if (input) {
        newSearch.set('input', input);
    }

    if (kind) {
        newSearch.set('kind', kind);
    }

    setSearchParams(newSearch, { replace: true });
    setLocationState({ ...initLocationState });
};
